<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Загрузка новых фотографий к препаратам</h5>
      </div>
      <div class="card-body">
        <!--        <DrugSearchNew-->
        <!--          ref="drug"-->
        <!--          :onSelect="(d) => objectId = d?.id ?? 'all'"-->
        <!--        />-->
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading && history.length">
          <table class="table mt-1 table-sm table-hover">
            <tbody>
            <tr v-for="r in history">
              <td>{{ r.file_name }}</td>
              <td>{{ printDate(r.created_at) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div>
          <UploadCustomWithPreview
            :noUseCompress="true"
            :allowToUpload="true"
            :extraData="{type: 2, object: 'new_drug_photos', objectId: objectId}"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import UploadCustomWithPreview from "@/components/images/UploadCustomWithPreview.vue";
import api from "@/api";

export default {
  components: {UploadCustomWithPreview, DrugSearchNew,},
  data() {
    return {
      loading: false,
      objectId: 'all',
      history: [],
    }
  },
  created() {
    this.getUploadHistory();
  },
  methods: {
    async getUploadHistory() {
      this.loading = true;
      const {data} = await api.index('/new/files/uploadHistory');
      if (data.success) {
        this.history = data.records;
      }
      this.loading = false;
    }
  }
}
</script>
